import React from 'react';

import { getSortFields } from 'apps/promo/components/form-multi/utils';
import { URL_SOCIAL_LINKS } from 'apps/promo/constants/UrlConstants';

import styles from './Footer.module.css';

function SocialLinks(props) {
    const { links } = props;

    const getLinks = (arrLinks) => {
        return getSortFields(arrLinks).map(({ isBlank, name, url }) => {
            return (
                <a key={name.replace(/\s/g, '')} rel="noreferrer noopener nofollower" target={isBlank ? '_blank' : '_self'} href={url} aria-label={name}>
                    <img src={`${URL_SOCIAL_LINKS}/${name}.svg`} alt={name} width="32" height="32" loading="lazy" />
                </a>
            );
        });
    };

    return <div className={styles.socialLinksContainer}>{links ? getLinks(links) : null}</div>;
}
export default SocialLinks;
